import { Chip, styled } from '@mui/material';


export const AdjustEBITDAChipStylesWrapper = styled('div')({
  width: '9rem',
  height: '1.5rem',
  display: 'flex',
  flexDirection: 'row-reverse',
});

export const StyledChip = styled(Chip)<{ isSelected?: boolean }>(({ theme, isSelected = false }) => ({
  fontSize: '0.775rem',
  zIndex: 2,
  padding: `${theme.spacing(0.25)} 0`,
  marginRight: theme.spacing(2),
  fontWeight: 'bold',
  textTransform: 'uppercase',
  backgroundColor: isSelected ? theme.palette.primary.main : theme.palette.common.white,
  color: isSelected ? theme.palette.common.white : theme.palette.primary.main,
  '&:hover': {
    backgroundColor: isSelected ? theme.palette.primary.dark : theme.palette.grey[100],
  },
}));